export const currentYear = typeof window !== `undefined` ? new window.Date().getFullYear() : null;
